var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "overlay-additional" }, [
    _c("h2", {
      staticClass: "overlay-additional__title",
      domProps: {
        innerHTML: _vm._s(_vm.$t("cart.additionalProducts.overlay.title"))
      }
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "overlay-additional__items" },
      _vm._l(_vm.additionalProducts, function(product) {
        return _c(
          "div",
          {
            key: product.rule.productId,
            staticClass: "overlay-additional__item"
          },
          [
            _c(_vm.icon(product.icon), {
              tag: "component",
              staticClass: "overlay-additional__item-icon"
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "overlay-additional__item-name",
              domProps: { innerHTML: _vm._s(product.name) }
            }),
            _vm._v(" "),
            _c("QuantityCounter", {
              attrs: {
                quantity: product.quantity,
                "base-class": "overlay-additional__item-quantity"
              },
              on: {
                sub: function($event) {
                  return _vm.quantityItemSubstract(product)
                },
                add: function($event) {
                  return _vm.quantityItemAdd(product)
                }
              }
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "overlay-additional__item-price",
              class: {
                "overlay-additional__item-price--show": product.total > 0
              },
              domProps: {
                innerHTML: _vm._s(
                  _vm.$options.filters.fwgpricecent(product.total, "long")
                )
              }
            })
          ],
          1
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", {
      staticClass: "overlay-additional__total",
      domProps: {
        innerHTML: _vm._s(
          _vm.$options.filters.fwgpricecent(
            this.additionalProductsTotal,
            "long"
          )
        )
      }
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "overlay-additional__buttons" },
      [
        _c("Button", {
          staticClass: "overlay-additional__submit",
          attrs: {
            text: _vm.$t("cart.additionalProducts.overlay.acceptButton"),
            level: "primary",
            type: "button"
          },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.onAdjust.apply(null, arguments)
            }
          }
        }),
        _vm._v(" "),
        _c("a", {
          staticClass: "overlay-additional__reset",
          attrs: { href: "" },
          domProps: {
            innerHTML: _vm._s(
              _vm.$t("cart.additionalProducts.overlay.resetButton")
            )
          },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.onReset.apply(null, arguments)
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }